import { sharedSchema } from "@shared-database/pgSchema";
import { KnowledgeCommunity } from "@shared-database/models/rag/knowledge-community";
import { KnowledgeEntity } from "@shared-database/models/rag/knowledge-entity";
import {
  leoID,
  leoNotNullForeignID,
  timestampColumns,
} from "@shared-database/utils";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";
import { index, uniqueIndex } from "drizzle-orm/pg-core";

/**
 * Membership rows connecting profile graph communities to their entities.
 *
 * Community detection rewrites these rows transactionally for a profile graph
 * generation. Retrieval and visualization use them to expand community
 * reports back to the accessible entities they summarize.
 */
export const KnowledgeCommunityMember = sharedSchema.table(
  "KnowledgeCommunityMember",
  {
    // Mixins
    ...timestampColumns,

    // Properties
    id: leoID("id"),

    // References
    communityId: leoNotNullForeignID("communityId").references(
      () => KnowledgeCommunity.id,
      { onDelete: "cascade" },
    ),
    entityId: leoNotNullForeignID("entityId").references(
      () => KnowledgeEntity.id,
      { onDelete: "cascade" },
    ),
  },
  (table) => [
    uniqueIndex("KnowledgeCommunityMember_uniqueIdx").on(
      table.communityId,
      table.entityId,
    ),
    index("KnowledgeCommunityMember_communityIdx").on(table.communityId),
    index("KnowledgeCommunityMember_entityIdx").on(table.entityId),
  ],
);

// Types
export type KnowledgeCommunityMemberType = InferSelectModel<
  typeof KnowledgeCommunityMember
>;
export type KnowledgeCommunityMemberInsertType = InferInsertModel<
  typeof KnowledgeCommunityMember
>;
